export class UploadQuota {
  private remaining: number | null = null;

  reset(canUploadImages: any): void {
    const limit = Number(canUploadImages);
    this.remaining = canUploadImages === null || canUploadImages === undefined || canUploadImages === "" || isNaN(limit)
      ? null
      : Math.max(limit, 0);
  }

  check(count: number, warn: (message: string) => void): boolean {
    if (this.remaining === null || count <= this.remaining) return true;
    warn(`As per your Image Upload limit you can only upload or click maximum of ${this.remaining} Vehicle / Document Images.`);
    return false;
  }

  reserve(count: number, warn: (message: string) => void): boolean {
    if (!this.check(count, warn)) return false;
    if (this.remaining !== null) this.remaining -= count;
    return true;
  }

  release(count = 1): void {
    if (this.remaining !== null) this.remaining += count;
  }
}
